import { useState } from "react";
import styles from "./PaymentGatewaySelection.module.css";
import iciciLogo from "../../Assets/Images/PaymentGateway/icici-logo.png";
import razorpayLogo from "../../Assets/Images/PaymentGateway/razorpay-logo2.png";
import axios from "axios";
import { errorTost } from "../../Services/Toast";
import { CircularProgress } from "@mui/material";

const gateways = [
  {
    id: "razorpay",
    name: "Razorpay Checkout",
    description: "Fast UPI, cards, wallets & net banking with instant settlement",
    logo: razorpayLogo,
  },
  {
    id: "icici",
    name: "ICICI Secure Payments",
    description: "Reliable banking-grade payment processing powered by ICICI Bank.",
    logo: iciciLogo,
  },
];

// Icons for UI
const IconX = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const IconCheck = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const IconArrowRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
  </svg>
);

const IconShield = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </svg>
);

const IconLock = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const PaymentGatewaySelection = ({ open = true, onClose, allotmentPaymentResponse, payableAmount, allotmentDetails, sdrAmount, handleSDRPayment, type, selectedToken, tokenPaymentResponse }) => {
  
  console.log("PaymentGatewaySelection rendered with sdrAmount: ", sdrAmount);
  console.log("PaymentGatewaySelection rendered with sdrAmount: ", payableAmount);

  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(false);

  const createICICIPaymentOrder = async (obj) => {
    try {
      const resp = await axios.post(
        `${process.env.REACT_APP_PAYMENT_LINK_URL}payments/create-order-icici`,
        obj
      );
      console.log("create-order-icici resp ===> ", resp);
      return resp;
    } catch (err) {
      throw err;
    }
  };

  // SDR
  const createICICIPaymentOrderSDR = async () => {
     setLoading(true);

    try {
      // Create Object
      const SDRTransactionObj = {
        amount: sdrAmount,
        type: "SDR",
        transactionObj: {
          amount: sdrAmount,
          transactionType: allotmentDetails.pricingType,
          modeOfPayment: "Razorpay-Customer Portal",
          allotmentPaymentId: allotmentDetails.allotmentPaymentId,
          unitId: allotmentDetails?.unitId?.unitId,
          inventoryMergeId: allotmentDetails?.inventoryMergedId?.inventoryMergeId,
          leadId: allotmentDetails.leadId.leadId,
          status: "pending",
        },
      };
      console.log("allotmentTransactionObj ===> ", SDRTransactionObj);

      // Call Initiate Sale (create order)
      const iciciResponse = await createICICIPaymentOrder(SDRTransactionObj);
      setLoading(false);
      console.log("RESPONSE FROM ICICI ===> ", iciciResponse);
      if (iciciResponse?.data && iciciResponse?.data?.success && iciciResponse?.data?.data?.paymentUrl != '') {
        // Navigate customer to payment link
        const paymentUrl = iciciResponse?.data?.data?.paymentUrl;
        window.open(paymentUrl, '_blank');  // '_blank' ensures it opens in a new tab
        onClose();
      } else {
        errorTost("Currently the selected method is facing some issues. Please try another Payment Method.");
        onClose();
      }
    } catch (error) {
      setLoading(false);
      errorTost("Currently the selected method is facing some issues. Please try another Payment Method.");
      onClose();
    }
  }

  // ALLOTMENT
  const createICICIPaymentOrderForAllotment = async () => {
     setLoading(true);

    try {
      // Create Object
      const allotmentTransactionObj = {
        amount: payableAmount,
        type: "Allotment",
        transactionObj: {
          amount: payableAmount,
          transactionType: allotmentDetails.pricingType,
          modeOfPayment: "Razorpay-Customer Portal",
          allotmentPaymentId: allotmentDetails.allotmentPaymentId,
          unitId: allotmentDetails?.unitId?.unitId,
          inventoryMergeId: allotmentDetails?.inventoryMergedId?.inventoryMergeId,
          leadId: allotmentDetails.leadId.leadId,
          status: "pending",
        },
      };
      console.log("allotmentTransactionObj ===> ", allotmentTransactionObj);

      // Call Initiate Sale (create order)
      const iciciResponse = await createICICIPaymentOrder(allotmentTransactionObj);
      setLoading(false);
      console.log("RESPONSE FROM ICICI ===> ", iciciResponse);
      if (iciciResponse?.data && iciciResponse?.data?.success && iciciResponse?.data?.data?.paymentUrl != '') {
        // Navigate customer to payment link
        const paymentUrl = iciciResponse?.data?.data?.paymentUrl;
        window.open(paymentUrl, '_blank');  // '_blank' ensures it opens in a new tab
        onClose();
      } else {
        errorTost("Currently the selected method is facing some issues. Please try another Payment Method.");
        onClose();
      }
    } catch (error) {
      setLoading(false);
      errorTost("Currently the selected method is facing some issues. Please try another Payment Method.");
      onClose();
    }
  }

  // TOKEN
  const createICICIPaymentOrderForToken = async () => {
     setLoading(true);

    try {
      // Create Object
   const TokenTransactionObj = {
              amount: payableAmount,
              type: "Token",
              transactionObj: {
                eventTokenId: selectedToken.eventTokenId.eventTokenId,
                paymentId: selectedToken.paymentId,
                leadId: selectedToken.leadId,
                status: "pending",
                amount: payableAmount,
              },
            };
      console.log("allotmentTransactionObj ===> ", TokenTransactionObj);

      // Call Initiate Sale (create order)
      const iciciResponse = await createICICIPaymentOrder(TokenTransactionObj);
      setLoading(false);
      console.log("RESPONSE FROM ICICI ===> ", iciciResponse);
      if (iciciResponse?.data && iciciResponse?.data?.success && iciciResponse?.data?.data?.paymentUrl != '') {
        // Navigate customer to payment link
        const paymentUrl = iciciResponse?.data?.data?.paymentUrl;
        window.open(paymentUrl, '_blank');  // '_blank' ensures it opens in a new tab
        onClose();
      } else {
        errorTost("Currently the selected method is facing some issues. Please try another Payment Method.");
        onClose();
      }
    } catch (error) {
      setLoading(false);
      errorTost("Currently the selected method is facing some issues. Please try another Payment Method.");
      onClose();
    }
  }

  // ICICI TRANSACTIONS HANDLER
  const handleICICI = async () => {

    console.log("ICICI Payment Gateways Selected");
    console.log("Type is :", type)

    if(type === "sdr") {
        await createICICIPaymentOrderSDR()
    }
    if(type === "allotment") {
        await createICICIPaymentOrderForAllotment();
    }
    if(type === "token") {
      console.log("Initiating ICICI Payment for Token...");
      await createICICIPaymentOrderForToken();
    }
   
  };

  // RAZORPAY HANDLER
  const handleRazorpay = () => {
    console.log("Razorpay Selected");
    console.log("Opening Razorpay Platform...");
    console.log("Type is :", type)
    //open razorpay modal for allotment payment
    if(type === "sdr") {
      handleSDRPayment(sdrAmount);
    }
    if (type === "allotment") {
      allotmentPaymentResponse(payableAmount);
    }
    if(type === "token") {
      tokenPaymentResponse(payableAmount);
    }
    //close the pgselection modal
    onClose();
  };

  const handleContinuePayment = async () => {
    console.log("selected is ===> ", selected);
    console.log("payableAmount is ===> ", payableAmount);

    if (selected === "icici") {
      await handleICICI();
    }
    if (selected === "razorpay") {
      handleRazorpay();
    }
  };

  if (!open) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.backdrop} onClick={onClose} />
      <div className={styles.modal}>
        {/* Header */}
        <div className={styles.header}>
          <div className={styles.headerRow}>
            <div>
              <h2 className={styles.title}>Select Payment Gateway</h2>
              <p className={styles.subtitle}>Choose your preferred payment method</p>
            </div>
            <button className={styles.closeBtn} onClick={onClose}>
              <IconX />
            </button>
          </div>
        </div>

        {/* Gateway Cards */}
        <div className={styles.gatewayList}>
          {gateways.map((gw) => {
            const isSelected = selected === gw.id;
            return (
              <button
                key={gw.id}
                className={`${styles.card} ${isSelected ? styles.cardSelected : ""}`}
                onClick={() => setSelected(gw.id)}
              >
                <div className={`${styles.checkCircle} ${isSelected ? styles.checkCircleSelected : styles.checkCircleDefault}`}>
                  {isSelected && <IconCheck />}
                </div>

                <div className={styles.cardContent}>
                  <div className={styles.logoBox}>
                    <img src={gw.logo} alt={`${gw.name} logo`} />
                  </div>
                  <div className={styles.cardText}>
                    <h3 className={styles.cardName}>{gw.name}</h3>
                    <p className={styles.cardDesc}>{gw.description}</p>
                  </div>
                </div>

                <div className={styles.securityBadge}>
                  <IconShield />
                  <span>PCI DSS Compliant · 256-bit SSL</span>
                </div>
              </button>
            );
          })}
        </div>

        {/* Footer */}
        <div className={styles.footer}>
          <button
            onClick={handleContinuePayment}
            disabled={!selected || loading} // Disable when selected is false or loading is true
            className={`${styles.continueBtn} ${selected ? styles.continueBtnActive : styles.continueBtnDisabled}`}
          >
            {loading ? (
            <span className={styles.spinner} />
            ) : (
              <>
                Continue Payment
                <IconArrowRight />
              </>
            )}
          </button>

          <div className={styles.secureNote}>
            <IconLock />
            <span>Secured with 256-bit SSL encryption</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentGatewaySelection;